export const enum AiChatLandingHeroSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export interface AiChatLandingHeroProps {
  className?: string;
  size?: AiChatLandingHeroSize;
  hideTip?: boolean;
  refreshKey?: number;
}
